import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/site-pages/Founders.tsx");
